import { render, staticRenderFns } from "./user-info.vue?vue&type=template&id=34018800&scoped=true&"
import script from "./user-info.vue?vue&type=script&lang=js&"
export * from "./user-info.vue?vue&type=script&lang=js&"
import style0 from "./user-info.vue?vue&type=style&index=0&id=34018800&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34018800",
  null
  
)

export default component.exports